// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d4ab7a1","453":"91d3723c","455":"a61b6ab9","977":"25fd59cc"}[chunkId] + ".chunk.js";
};